export const IconExchange = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconExchange_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconExchange_svg__a)">
        <path d="m5.825 17 1.9 1.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.287a.92.92 0 0 1-.7-.287l-3.6-3.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 2.425 16q0-.2.062-.375A.9.9 0 0 1 2.7 15.3l3.6-3.6a.93.93 0 0 1 .687-.275q.413 0 .713.275.3.3.3.713 0 .412-.3.712L5.825 15H20q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 20 17zm12.35-8H4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 3 8q0-.424.287-.713A.97.97 0 0 1 4 7h14.175l-1.9-1.9a.92.92 0 0 1-.287-.7Q16 4 16.3 3.7q.3-.275.7-.288t.7.288l3.6 3.6q.15.15.212.325.063.175.063.375t-.062.375a.9.9 0 0 1-.213.325l-3.6 3.6a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.713 0-.412.3-.712z" />
      </g>
    </svg>
  );
};
